var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "143.8%",
    height: "143.8%",
    x: "-21.9%",
    y: "-21.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M40.337 15.809c.204 1.07.31 2.179.31 3.313v21.17c0 3.235-2.43 5.708-5.608 5.708H23.824v-3.805h13.084v-4.048h-7.477V26.714l3.787-3.787h3.69v-3.69zM23.824 2a16.6 16.6 0 0 1 10.402 3.629l-2.693 2.693a12.93 12.93 0 0 0-7.71-2.517c-7.29 0-13.084 5.898-13.084 13.317v3.805h6.188l-9.914 9.915-.01-.178L7 32.44V19.122C7 9.61 14.477 2 23.824 2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#CFD6DA"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    filter: "url(#a)",
    transform: "translate(26 26)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M47.137 3.692 3.692 47.137.863 44.308 44.308.863z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUsers);
export default __webpack_public_path__ + "static/media/noUsers.70978c1d5ffda2fea3a35ba726046fa9.svg";
export { ForwardRef as ReactComponent };